import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'yes-no',
  template: `
  <div class="controls-group-h" [formGroup]="form">
    <label class="form-radio-label" >                       
      <span class="checkmark"></span> {{text}}  
      <span><font color="red"> * </font></span> 
    </label>
    &nbsp; &nbsp;           
    <label class="form-radio-label" >                                                 
      <input type="radio" [formControlName]="controlName" value="1">
      <span class="checkmark blue">כן</span>
    </label>                                  
    &nbsp;  
    <label class="form-radio-label" >                 
      <input type="radio" [formControlName]="controlName" value="2">
      <span class="checkmark blue">לא</span>   
    </label>
    <control-messages [control]="form.controls[controlName]"></control-messages>
  </div>
  `,
  styles: [`
  `
  ]
})

export class YesNoComponent {
  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() text="";  
  
  constructor () {}
}
